module.exports = __webpack_public_path__ + "static/media/track-dirt-single.82df9975.png";